/** @jsxImportSource @emotion/react */

import Typography from '@mui/material/Typography'
import { FC, useState } from 'react'
import TabsNavigation from 'components/TabsNavigation'
import { TabsItem } from 'types/tabsItem'
import FAQ from 'pagesNew/FAQ'
import { FaqPages } from '__generatedTypes__/globalTypes'
import * as classes from './styles'

enum DailyWarmupTabs {
  FAQ = 'FAQ',
}

const tabs = Object.values(DailyWarmupTabs).map((item) => ({ id: item, title: item }))

export const DailyWarmup: FC = () => {
  const [activeTab, setActiveTab] = useState<TabsItem>(tabs[0])

  const renderTab = () => {
    const { title } = activeTab

    if (title === DailyWarmupTabs.FAQ) {
      return <FAQ page={FaqPages.DailyWarmupCalendar} />
    }
  }

  return (
    <div css={classes.container}>
      <Typography variant="title3" css={classes.title}>
        Daily Warmup Calendar
      </Typography>

      <TabsNavigation<TabsItem> tabs={tabs} value={activeTab} onChange={setActiveTab} css={classes.tabs} />

      {renderTab()}
    </div>
  )
}
